import DOMPurify from "dompurify";

const escape = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export const toHtml = (content = "") => {
  if (/<\/?[a-z][\s\S]*>/i.test(content)) return content;
  return content.split(/\n{2,}/).filter((p) => p.trim()).map((p) => `<p>${escape(p).replace(/\n/g, "<br>")}</p>`).join("");
};

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") node.setAttribute("rel", "noopener noreferrer");
});

export const sanitizeHtml = (content) => DOMPurify.sanitize(toHtml(content), { ADD_ATTR: ["target"] });
